import { useCallback } from 'react';

export function useS3Upload() {
  const generateAwsSignedUrl = useCallback(async (file) => {
    try {
      const res = await fetch(process.env.NEXT_PUBLIC_PRESIGNEDURL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          filename: file.name,
          filetype: file.type,
        }),
      });

      const { url, key } = await res.json();
      return { success: true, url, key };
    } catch (error) {
      return { success: false, error: error.message };
    }
  }, []);

  const uploadFilesToS3 = useCallback(async (files, presignedUrl, key) => {
    try {
      const uploadPromises = files?.map(async (file) => {
        try {
          const uploadFile = await fetch(presignedUrl, {
            method: 'PUT',
            headers: {
              'Content-Type': file.type,
            },
            body: file,
          });

          return {
            file,
            s3Key: key,
            path: uploadFile?.url,
            success: true,
          };
        } catch (error) {
          return { file, success: false, error: error.message };
        }
      });

      const results = await Promise.all(uploadPromises);
      const successfulUploads = results.filter((result) => result.success);
      const failedUploads = results.filter((result) => !result.success);

      return {
        successful: successfulUploads,
        failed: failedUploads,
        total: results.length,
      };
    } catch (error) {
      return {
        successful: [],
        failed: files.map((file) => ({ file, success: false, error: error.message })),
        total: files.length,
      };
    }
  }, []);

  return {
    generateAwsSignedUrl,
    uploadFilesToS3,
  };
}
